<template>
  <!-- <div
    ><p class="t-white">{{ deliveryOption }}</p>
  </div> -->

  <template
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <div
      class="d-flex-row space-between"
      v-if="
        packSelectedOption?.const_title !== 'vip_loot' &&
        packSelectedOption?.const_title !== 'group_loot'
      "
    >
      <p
        class="t-grey font-family-2 regular-l"
        v-if="!packSelectedOption.title.includes('new_text')"
      >
        {{ packSelectedOption.title }}
      </p>
      <p
        class="t-grey font-family-2 regular-l"
        v-if="packSelectedOption.title.includes('new_text')"
      >
        {{ $t(packSelectedOption.title) }}
      </p>

      <p class="t-white font-family-2 bold-l">
        {{ renderPrice(packSelectedOption) }}
      </p>
    </div>
  </template>

  <template
    v-for="packSelectedOption in numberOfBoostersOption"
    :key="packSelectedOption"
  >
    <div
      class="d-flex-row space-between"
      v-if="
        packSelectedOption?.const_title !== 'vip_loot' &&
        packSelectedOption?.const_title !== 'group_loot'
      "
    >
      <p
        class="t-grey font-family-2 regular-l"
        v-if="!packSelectedOption.title.includes('new_text')"
      >
        {{ packSelectedOption.title }}
      </p>
      <p
        class="t-grey font-family-2 regular-l"
        v-if="packSelectedOption.title.includes('new_text')"
      >
        {{ $t(packSelectedOption.title) }}
      </p>

      <p class="t-white font-family-2 bold-l">
        {{ renderPrice(packSelectedOption) }}
      </p>
    </div></template
  >
</template>

<script>
import { calculateCurrency } from "~/calculate/calculatePrice";
export default {
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      let gamePackOption = this.getGamePack.pack_options || [];
      if (
        this.currentGameSlug === "call-of-duty-boost" &&
        this.currentGamePackSlug !== "black-ops-6-weapon-leveling-boost"
      ) {
        gamePackOption = this.getGamePack.pack_extra_options || [];
      }
      const packSelectedOptions = gamePackOption.filter(
        (option) =>
          this.checkoutStore.getPackOptions.includes(option.id) &&
          ![
            "one_extra_boosters",
            "two_extra_boosters",
            "three_extra_boosters",
            "four_extra_boosters",
          ].includes(option?.const_title)
      );
      return [...packSelectedOptions];
    },
    selfPlayOptions() {
      const gamePackOptions =
        this.getGamePack.pack_options?.filter(
          (packOp) => packOp?.const_title === "self_play"
        ) || [];

      return gamePackOptions;
    },
    isDuoOptionSelected() {
      const option = this.selfPlayOptions[0];
      const selectedOption = this.checkoutStore.getPackOptions.find(
        (op) => op === option?.id
      );

      if (!selectedOption) {
        return false;
      }
      return true;
    },
    numberOfBoostersOption() {
      if (!this.isDuoOptionSelected) return [];
      let gamePackOption = this.getGamePack.pack_options?.filter((option) =>
        [
          "one_extra_boosters",
          "two_extra_boosters",
          "three_extra_boosters",
          "four_extra_boosters",
        ].includes(option?.const_title)
      );
      const packSelectedOptions = gamePackOption.filter((option) =>
        this.checkoutStore.getPackOptions.includes(option.id)
      );
      if (packSelectedOptions?.length <= 0) {
        // return [{ title: this.$t("one_booster"), price: this.$t('checkout.free') }];
        return [];
      }
      return [
        { title: this.$t("one_booster"), price: this.$t("checkout.free") },
        ...packSelectedOptions,
      ];
    },
  },

  methods: {
    extractNumber(title) {
      const match = title.match(/^\+(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    },
    renderPrice(option) {
      if (option.type === "variable") {
        if (option.price_type === 0) {
          return `+${option.price}%`;
        } else if (option.price_type === 1) {
          return `-${option.price}%`;
        }
      }
      if (option.type === "fixed") {
        if (option.price_type === 0) {
          return `+${parseFloat(option.price).toFixed(2)}${
            this.getUserCurrencyCode
          }`;
        } else if (option.price_type === 1) {
          return `-${this.getUserCurrencyCode}`;
        }
        return parseFloat(calculateCurrency(option.price)).toFixed(2);
      }
      if (option.type === "free") {
        return this.$t("checkout.free");
      }
      return option.price;
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    const { getUserCurrencyCode } = useUserStore();
    const { getGamePack } = useGameStore();
    const { currentGameSlug, currentGamePackSlug } = useGameComposable();
    return {
      currentGamePackSlug,
      checkoutStore,
      getUserCurrencyCode,
      getGamePack,
      currentGameSlug,
    };
  },
};
</script>
